// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3I_uc","label":"Radio_label__3CYmb","checkMark":"Radio_checkMark__2qP9U","disabled":"Radio_disabled__3dQp9"};